import type {ParameterValue} from "#graph/nodes/graph/helpers"
import {parameterValue} from "#graph/nodes/graph/helpers"
import {z} from "zod/v4-mini"
import type {GraphNodeDefinition} from "#graph/nodes/graph/types"

export const getPropertyNodeDefinition = <StructType extends {[x: string]: unknown}, KeyType extends string & keyof StructType, Context>(
    keySchema: z.ZodMiniType<KeyType, KeyType>,
    valueSchema: z.ZodMiniType<StructType[KeyType]>,
    structSchema: z.ZodMiniType<StructType>,
) =>
    ({
        label: "Get Property Node",
        nodeClass: "GetProperty",
        validation: {
            parameters: z.strictObject({key: keySchema, value: parameterValue(structSchema)}),
            returns: valueSchema,
        },
    }) satisfies GraphNodeDefinition<StructType[KeyType], {key: KeyType; value: ParameterValue<StructType, Context>}>
